import {
  MockMap,
} from '@ama-sdk/core';
import {
  AcceptanceRepository,
  combineCheckInBaggagePolicies,
  createAcceptance,
  createBaggage,
  createJourneyElement,
  createJourneyElementCommon,
  createMockData,
  createMockDataWithResponse,
  MockAcceptance,
  MockJourneyElementCommon,
} from '@dapi/sdk/spec';
import {
  authorization,
  namedTraveler,
} from '../../mock';
import {
  acceptedJourney,
  addedBaggageTemplate,
  defaultCheckInBaggagePolicies,
  firstCHSeatOnJourney,
  journeys,
  noItemToPayError,
  paymentRecords,
  seatmap,
  seatsToPay,
  sentBoardingPassResultWithDropOffTime,
} from '../../mock/data';

/**
 * OW 1Journey
 * 1ADT
 * Chargeable seats journey
 */

const checkedInJourneyElementFirstSeat: MockJourneyElementCommon = createJourneyElementCommon({
  template: {
    journeyElement: createJourneyElement({
      template: {
        seat: firstCHSeatOnJourney[0],
        checkInStatus: 'accepted',
        traveler: namedTraveler,
        travelerId: namedTraveler.id
      }
    })
  }
});
const acceptance: MockAcceptance = createAcceptance({
  template: {
    checkedInJourneyElements: [checkedInJourneyElementFirstSeat],
    isAccepted: true
  }
});
export const ow1Journey1AdtChargeableSeats: MockMap = {
  authorizeJourneyPaymentRecord: [createMockData(authorization)],
  confirmJourneyPaymentRecord: [createMockData(paymentRecords)],
  createJourneyPaymentRecord: [createMockData(paymentRecords)],
  addJourneyBags: [createMockData([
    createBaggage({
      template: addedBaggageTemplate,
      id: 0
    })])],
  generateBoardingPasses: [createMockDataWithResponse(sentBoardingPassResultWithDropOffTime, 201),
    createMockDataWithResponse(sentBoardingPassResultWithDropOffTime, 201),
    createMockDataWithResponse(sentBoardingPassResultWithDropOffTime, 201)],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies([defaultCheckInBaggagePolicies]).items)],
  getJourneyUnpaidItems: [
    createMockData(seatsToPay),
    createMockData(noItemToPayError),
    createMockData(seatsToPay),
    createMockData(seatsToPay),
    createMockData(noItemToPayError)
  ],
  assignSeatToJourneyElement: [
    createMockDataWithResponse(firstCHSeatOnJourney[0], 201)
  ],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201), createMockDataWithResponse(acceptance, 201), createMockDataWithResponse(acceptance, 201)],
  retrieveJourneyBaggages: [createMockData([])],
  retrieveJourneys: [
    createMockDataWithResponse(journeys, 201),
    createMockDataWithResponse([acceptedJourney], 201)
  ],
  retrieveJourney: [
    createMockData({
      ...acceptedJourney,
      journeyElements: [checkedInJourneyElementFirstSeat]
    })
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(seatmap)]
};
